/*
	FrontLaucher main js file 
*/

//es6 style
import slick from 'slick-carousel';
import '!style!css!slick-carousel/slick/slick.css';
import 'foundation-sites';

//require.js style
require('!style!css!fancybox/dist/css/jquery.fancybox.css');
require("expose?jQuery!jquery"); // global jquery (but shouldn't be used without webpack)
require('!style!css!sweetalert/dist/sweetalert.css');
require("expose?sweetalert!sweetalert");
require('!style!css!tooltipster/css/tooltipster.css');
require('./cookie.js');

const fancybox = require('fancybox')($);
const TweenMax = require("gsap");
const MatchHeight = require("jquery-match-height");
const lazyload = require("jquery-lazyload");
const tooltipster = require("script!tooltipster/js/jquery.tooltipster.js");

var App = {
	initialize: function(){
	    $('.fancybox').fancybox();
	    $(document).foundation();
	},
	initMainSlider: function(){

		var $slider = $('#slider .slidable');

		$slider.slick({
			slidesToShow:1,
			slidesToScroll:1,
			fade: true,
			arrows:false,
			autoplay:true,
			dots:true
		})

		this.sliderAnimations();
	},
	tooltips: function(){
		var $tp = $('.tooltip');

		if($tp.length > 0){
			$tp.each(function(){$(this).tooltipster({
				theme: 'sady',
				animation: 'grow'
			})});
		} 
	},
	sliderAnimations: function(){
		var $slider = $('#slider');
		var $sliderImg = $('#slider img');
		var $sliderMask = $('#slider .slideMask');

		var tl = new TimelineMax({paused: true, useFrames: true});
			if(! window.matchMedia("(max-width: 1024px)").matches) {
				tl.to($sliderImg, 20, {
					y:40,
					ease: Power0.easeNone
				},0).to($sliderMask, 20, {
					y:65,
					ease: Power0.easeNone
				},0);

				var scrollTop = $(window).scrollTop();

				var docHeight = $slider.outerHeight();

				var scrollPercent = (scrollTop) / (docHeight / 3);
				var scrollPercentRounded = Math.round(scrollPercent*100)/100;
				if(scrollPercentRounded <= 1) {
					tl.progress( scrollPercent ).pause();
				}
				else{
					tl.progress( 100 ).pause();
				}

				$(window).scroll(function(e){
					if(!window.matchMedia("(max-width: 1024px)").matches) {
						var scrollTop = $(window).scrollTop();
						var docHeight = $slider.outerHeight();
						var scrollPercent = (scrollTop) / (docHeight / 3);
						var scrollPercentRounded = Math.round(scrollPercent*100)/100;
						if(scrollPercentRounded <= 1) {
							tl.progress( scrollPercent ).pause();
						} else {
							tl.progress( 100 ).pause();
						}
					} else {
						tl.progress( 0 ).pause();
					}
				});	
			}
	},
	heightHelper : function(name){
		var $items = $(name);
		let maxHeight = 0;

		$items.each(function(){
			var $this = $(this);
			if( $this.outerHeight() > maxHeight){
				maxHeight = $(this).outerHeight();
			}
		})

		$items.css('height', maxHeight);
	},
	productsSlidableSlick: function(){
		var $carousel = $('#juiceCarousel .productSlidable');
		var $opt = {
			slidesToShow:4,
			slidesToScroll:4,
			autoplay:true,
			arrows:false,
			pauseOnHover: true,
			draggable:false,
			dots: true,
			arrows: true,
			responsive: [
			{
				breakpoint: 845,
				settings:{
					slidesToShow:3,
					slidesToScroll:3
				}
			},
			{
				breakpoint: 640,
				settings:{
					slidesToShow:2,
					slidesToScroll:2
				}
			},
			{
				breakpoint: 450,
				settings:{
					slidesToShow:1,
					slidesToScroll:1
				}
			}
			]
		}

		$carousel.slick($opt);
	},
	hashController: function(){
		var tag = window.location.hash;
			tag = tag.substr(1, tag.length);
			if(tag){

			setTimeout(function(){
				$('html, body').stop().animate({
				         scrollTop: $("#"+tag).offset().top - $('#header').outerHeight()
				}, 300);	
			},10);


			}
	},
	whiteCircleInit: function(){
		var $whiteCircle = $('.whiteCircle .wrapper span');

		$whiteCircle.click(function(e){
			e.preventDefault();
			e.stopPropagation();
			$('html, body').animate({
				scrollTop: $('#juiceCarousel').offset().top - 25
			});
		})
	},
	cartTabs: function(){
		var $tabs =  $('.cartTabs li a');

		$tabs.click(function(e){
			e.preventDefault();
			e.stopPropagation();
			$('.tabContent').removeClass('active');
			$('.tabContent[data-tab="'+$(this).attr('data-tab')+'"]').addClass('active');

				$('html, body').stop().animate({
				         scrollTop: $('.tabs.cartTabs.shopCart > ul').offset().top + $('.tabs.cartTabs.shopCart > ul').outerHeight()
				}, 300);			
		})
	},
	menuController: function(){
		var $menuTrigger = $('.menuController'); 

		$menuTrigger.click(function(){
			$(this).toggleClass('active');
			var $menu = $('header .wrapper .right > nav:first-child');
			var $menuLng = $('header .wrapper .right > nav.lng');
			$menu.toggleClass('active');
			$menuLng.toggleClass('active');
		})
	},
	menuScroller: function(){
		var $menuItems = $('.homeNav li');

		$menuItems.click(function(e){
			e.preventDefault();
			if($(this).attr('data-section') != '0'){
				var sectionNumber = parseInt( $(this).attr('data-section') );

				$('html, body').animate({
					scrollTop: $('section[data-section="'+sectionNumber+'"]').offset().top - 25
				});
			} else{
				window.location = e.target.href;
			}
		})
	},
	sweetHacks: function(){
		$(document).on('click','.sweet-overlay', function(e){
			e.stopPropagation();
			$('.sa-confirm-button-container button').trigger('click');
		})
	},
	greenCircle: function(){
		const $el = $('.greenCircle');
		const $span =  $el.find('span');
		const w = ($span.width() * 1.1) + 16 ;
		$span.css('position','absolute');
		

		$el.css({
			'width':w+ 'px',
			'line-height':w+ 'px',
			'opacity': 1
		})
	},
	historyMatch: function(){
		var $items = $('#history .wrapper article');
		$items.matchHeight();
	},
	initLazyLoad: function(){
		var $img = $('img.lazy');
		if($img.length > 0)
			$img.lazyload();
	},
	srcHandler: function(){
		var $img = $('.srcHandle.tC');

		if($img.length > 0){
			if($(window).scrollTop() > $('#slider').outerHeight() ){
					$img.each(function(){
						if($(this).attr('src') !== ''){
							$(this).attr('src', $(this).attr('data-src'));
							$(this).removeClass('tC');
						}
					})
			}
		}
	},
	init: function(){
		var self = this;
		document.addEventListener('DOMContentLoaded', function() {
			self.initialize(); 
            cartEngine.init();			
			self.initMainSlider();
			self.productsSlidableSlick();
			self.whiteCircleInit();
			self.menuController();
			self.menuScroller();
			self.cartTabs();
			self.hashController();
			self.greenCircle();
			self.historyMatch();
			self.sweetHacks();
			self.initLazyLoad();
			self.srcHandler();
			self.tooltips();
		}, false);

		window.onload = function() {
		};

		window.onresize = function() {

		};

		window.onscroll = function() {
			self.srcHandler();
		}
	}
}

App.init();

var cartEngine = {
    showCartWrapper: function(){
        var $cartWrapper = $('.shoppingCart');

        $('.goToPay').click(function(event) {
            event.preventDefault();
            $cartWrapper.slideDown('fast',function(){
            });
			$('html, body').stop().animate({
			         scrollTop: $('.shoppingCart').offset().top
			}, 300);            
        });
    },
    refreshOrderForms: function(){
        //return semanticHandler.dropdown();
    },
    init: function(){
        var self = this;
        self.refreshOrderForms();
        self.showCartWrapper();
    }
};

window.cartEngine = cartEngine;


/** WEBPACK FOOTER **
 ** ./app.js
 **/